// extracted by css-extract-rspack-plugin
export default {"image":"_a60b449f"};